import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import {InputButton, Image} from '@emersya/mpa-components';

export interface IOMSProcessButtonComponentConfiguration extends InputButton.Configuration {
	icon: string | null;
	textDisable? : boolean | null;
};

export class OMSProcessButtonComponent extends InputButton.Component<
	OMSProcessButtonComponent,
	IOMSProcessButtonComponentConfiguration
> {
	static override getInputEventSubType() {
		const parentClass = (<typeof CM.Component>(<any>this.prototype).__proto__.constructor);
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button', {});
		}
		return parentClass.type;
	};

	override async component_start(ev: STD.events.Event<any, any>) {
		if (this.component_configuration.icon) {
			const tr = STD.translationsManager.languages.reduce<Record<string, string>>((a, c) => {
				a[c] = 'icon process order';
				return a;
			}, {});
			const image = await this.component_instantiateOuterChild<Image.Configuration>(
				{
					type: 'image',
					id: 'icon',
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					configuration: {
						URL: this.component_configuration.icon.replace('$ASSETS/', app.clientAppParameters.app.assetsPath),
						'@translations': {
							name: tr
						}
					}
				}
			);
			void image;
		}
		await super.component_start(ev);
		if(this.component_configuration.textDisable){
			await this.component_find('@:title').component_disable();
		}
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IOMSProcessButtonComponentConfiguration
	) {
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = OMSProcessButtonComponent;
	export type Component = OMSProcessButtonComponent;
	export type Configuration = IOMSProcessButtonComponentConfiguration;
}
import manifestXMLSource from './OMSProcessButton.xml';
import './OMSProcessButton.scss';

CM.Manager.declare({
	id: 'oms-processButton',
	type: OMSProcessButtonComponent,
	manifest: manifestXMLSource
});
